import React from 'react';

import { Flex, FlexProps, useMantineTheme } from '@mantine/core';
import { BrowserContainer } from 'components/BrowserContainer';
import { ChatConversationView } from 'components/SmartAssistantComponents/ChatConversationView';
import { ChatHeader } from 'components/SmartAssistantComponents/ChatHeader';
import { useSubscriptionContext } from 'contexts/SubscriptionContext';
import { ChatMessage } from 'shared/interfaces/ChatMessage';
import { SmartAssistantVisualConfig } from 'shared/interfaces/SmartAssistant';

interface SmartAssistantPreviewerProps extends FlexProps {
  smartAssistantVisualConfig: SmartAssistantVisualConfig;
  messages: ChatMessage[];
}

export function SmartAssistantPreviewer({
  smartAssistantVisualConfig,
  messages,
  ...flexProps
}: SmartAssistantPreviewerProps) {
  const theme = useMantineTheme();
  const [subscription] = useSubscriptionContext();

  return (
    <BrowserContainer dark w="100%" h="100%" {...flexProps}>
      <Flex
        direction="row"
        w="100%"
        bg={smartAssistantVisualConfig.secondaryBackgroundColor}
        style={{ borderBottomLeftRadius: theme.spacing.xs, borderBottomRightRadius: theme.spacing.xs, flexGrow: 1 }}>
        <ChatConversationView
          w="100%"
          h="100%"
          style={{
            borderBottomRightRadius: theme.spacing.xs,
            borderBottomLeftRadius: theme.spacing.xs
          }}
          smartAssistantVisualConfig={smartAssistantVisualConfig}
          messages={messages}
          viewMode="preview"
          disableAnimation
          header={<ChatHeader smartAssistantVisualConfig={smartAssistantVisualConfig} />}
          displayPoweredBy={!subscription.product.removePoweredBy}
        />
      </Flex>
    </BrowserContainer>
  );
}
